import { render, staticRenderFns } from "./SearchScopusForm.vue?vue&type=template&id=25278f1e&scoped=true"
import script from "./SearchScopusForm.vue?vue&type=script&lang=js"
export * from "./SearchScopusForm.vue?vue&type=script&lang=js"
import style0 from "./SearchScopusForm.vue?vue&type=style&index=0&id=25278f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25278f1e",
  null
  
)

export default component.exports